import { useQuery, UseQueryOptions } from 'react-query';

import { ServiceHttpResponseError } from '../services/serviceHelpers';
import { getPackCalculator } from '../services/shippablePackDetails';
import { PackCalculator } from '../services/types';

const usePackCalculatorsList = ({
  ids,
  ...rest
}: {
  ids: string[] | undefined;
} & UseQueryOptions<PackCalculator[], ServiceHttpResponseError, PackCalculator[], any[]>) => {
  return useQuery(
    ['packCalculatorsList', ids],
    async () => {
      if (!ids || ids.length === 0) {
        return [];
      }
      const promises = ids.map(id => getPackCalculator(id));
      return Promise.all(promises);
    },
    {
      ...rest,
      enabled: Boolean(ids && ids.length > 0),
    },
  );
};

export default usePackCalculatorsList;
